import { useContext } from 'react';
import { SnackbarContext } from '../layout/AppLayout';

function useNotification() {
  const { setMessage, setSeverity, handleSnackbarOpen, handleSnackbarClose } =
    useContext(SnackbarContext);

  return {
    setMessage,
    setSeverity,
    handleSnackbarOpen,
    handleSnackbarClose,
  };
}

export default useNotification;
